import "./ventaCard.css";
import { formatFechaFactura } from "../../../../utils/fechas.js";
import { formatearPrecio } from "../../../../utils/precios.js";

export default function VentaCard({ factura, abierta, onToggle }) {
  return (
    <div className="factura-card" onClick={onToggle}>
      {/* ================= RESUMEN ================= */}
      <div className="factura-row">
        <div className="factura-info">
          <span>
            <strong>Factura #{factura.numero_factura}</strong>
          </span>
          <span>{formatFechaFactura(factura.fecha_factura)}</span>
          <span className={`estado estado-${factura.estado}`}>
            {factura.estado}
          </span>
        </div>

        <span className="factura-total">${formatearPrecio(factura.total)}</span>
      </div>

      {/* ================= DETALLE ================= */}
      {abierta && (
        <div className="factura-detalle">
          {factura.ventas?.map((venta, ventaIndex) => (
            <div
              key={
                venta.id_venta ??
                `venta-${factura.numero_factura}-${ventaIndex}`
              }
              className="venta-detalle"
            >
              <div className="venta-titulo">Venta #{venta.id_venta}</div>

              {venta.detalle_ventas?.map((item, itemIndex) => (
                <div
                  key={
                    item.id_detalle_venta ??
                    `detalle-${venta.id_venta}-${itemIndex}`
                  }
                  className="detalle-item"
                >
                  <span>
                    {item.cantidad} × {item.nombre_producto}
                  </span>

                  <span>
                    ${formatearPrecio(item.precio_unitario * item.cantidad)}
                  </span>
                </div>
              ))}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
